module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "sad-cloudy-car-2.7b68a710.png" + "?" + Date.now();